import AspectRatioWrapper from './AspectRatioWrapper';
import OverlayActions from './OverlayActions';

const rootCss = ({ palette }) => ({
  // the old `root` styles targeted AspectRatioWrapper's inner wrapper (via wrapperClassName), not its root
  '.PL-wrapper': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: palette.common.black,
  },
  '.PL-poster': {
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    position: 'absolute',
    objectFit: 'cover',
  },
});

export default function PlayerLoader({ className, poster }) {
  return (
    <AspectRatioWrapper className={className} css={rootCss} wrapperClassName="PL-wrapper">
      {poster && <img className="PL-poster" src={poster} />}
      <OverlayActions loading />
    </AspectRatioWrapper>
  );
}
